(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  (() => {
    if (window.ownartVisualMenuInitialized) return;

    window.ownartVisualMenuInitialized = true;

    const itemSelector = '.ownart-header--visual .ownart-menu-item--has-submenu';
    const triggerSelector = '.ownart-menu-item__top-link';
    const panelSelector = '.ownart-menu-panel';
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let closeTimer = null;
    let activeTouchItem = null;

    const getMenuItems = () =>
      Array.from(document.querySelectorAll(itemSelector)).filter((item) => item.querySelector(panelSelector));

    const clearCloseTimer = () => {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const setOpenMenuItem = (target) => {
      clearCloseTimer();

      const activeItem = target instanceof Element ? target.closest(itemSelector) : null;

      getMenuItems().forEach((item) => {
        const isOpen = desktopQuery.matches && item === activeItem;
        item.classList.toggle('is-open', isOpen);

        const trigger = item.querySelector(triggerSelector);
        if (trigger instanceof HTMLAnchorElement) {
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });

      if (!(activeItem instanceof HTMLElement) || !activeItem.querySelector(panelSelector)) {
        activeTouchItem = null;
      }
    };

    const scheduleClose = () => {
      if (closeTimer) return;

      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        setOpenMenuItem(null);
      }, 420);
    };

    document.addEventListener(
      'pointermove',
      (event) => {
        if (!desktopQuery.matches || event.pointerType !== 'mouse') return;

        if (event.target instanceof Element && event.target.closest(itemSelector)) {
          setOpenMenuItem(event.target);
          return;
        }

        scheduleClose();
      },
      { passive: true }
    );

    document.addEventListener('focusin', (event) => {
      if (event.target instanceof Element && event.target.closest(itemSelector)) {
        setOpenMenuItem(event.target);
        return;
      }

      if (event.target instanceof Element && event.target.closest('.ownart-header--visual .header__icons')) {
        setOpenMenuItem(null);
      }
    });

    document.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (document.activeElement instanceof Element && document.activeElement.closest(itemSelector)) {
          setOpenMenuItem(document.activeElement);
          return;
        }

        setOpenMenuItem(null);
      }, 0);
    });

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!(event.target instanceof Element)) return;

        if (event.target.closest('.ownart-header--visual .header__icons')) {
          setOpenMenuItem(null);
        }

        const navLink = event.target.closest(triggerSelector);
        if (navLink instanceof HTMLAnchorElement) {
          const navItem = navLink.closest(itemSelector);

          if (
            navItem instanceof HTMLElement &&
            navItem.querySelector(panelSelector) &&
            event.pointerType !== 'mouse' &&
            activeTouchItem !== navItem
          ) {
            event.preventDefault();
            navLink.dataset.ownartNavSuppressClick = 'true';
            activeTouchItem = navItem;
            setOpenMenuItem(navLink);
          }

          return;
        }

        if (!event.target.closest(itemSelector)) {
          scheduleClose();
        }
      },
      { capture: true }
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const navLink = event.target.closest(triggerSelector);
        if (!(navLink instanceof HTMLAnchorElement)) return;

        if (navLink.dataset.ownartNavSuppressClick === 'true') {
          event.preventDefault();
          delete navLink.dataset.ownartNavSuppressClick;
        }
      },
      { capture: true }
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpenMenuItem(null);
      }
    });

    desktopQuery.addEventListener('change', () => setOpenMenuItem(null));
  })();

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ownart-tiktok-connect"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ownart-tiktok-connect]').forEach((root) => {
    if (root.dataset.tiktokInitialized === 'true') return;

    const status = root.querySelector('[data-ownart-tiktok-status]');
    if (!status) return;

    root.dataset.tiktokInitialized = 'true';
    const params = new URLSearchParams(window.location.search);

    if (params.get('tiktok_connected') === '1') {
      status.textContent = status.dataset.labelConnected;
      status.classList.add('is-connected');
    } else if (params.has('tiktok_error')) {
      status.textContent = status.dataset.labelError;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
